import { TextAreaWithLabel } from '@adotel/components'
import { Typography, Divider, IconButton } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import DeleteIcon from '@material-ui/icons/Delete'
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom'
import React from 'react'

import { getTranslate } from '../../../../localization'
import {
  ConfirmPrimitiveReservationInput,
  RoomStayForCart
} from '../../../../types/cart'
import Form from './Form'
import { useStyles } from './styles/index.styles'

type GuestsDetailsFormProps = {
  confirmPrimitiveInput: ConfirmPrimitiveReservationInput
  setConfirmPrimitiveInput: React.Dispatch<
    React.SetStateAction<ConfirmPrimitiveReservationInput>
  >
  roomDetails: RoomStayForCart
  roomIndex: number
  max: number
}
const GuestsDetailsForm = ({
  confirmPrimitiveInput,
  setConfirmPrimitiveInput,
  roomDetails,
  roomIndex,
  max
}: GuestsDetailsFormProps) => {
  const classes = useStyles()
  const maxGuest = max

  const handleAddMore = () => {
    if (
      confirmPrimitiveInput.confirmRooms[roomIndex].profiles.length < maxGuest
    ) {
      setConfirmPrimitiveInput((prev) => ({
        ...prev,
        confirmRooms: [
          ...prev.confirmRooms.slice(0, roomIndex),
          {
            ...prev.confirmRooms[roomIndex],
            profiles: [
              ...prev.confirmRooms[roomIndex].profiles,
              {
                firstName: '',
                lastName: '',
                email: '',
                identificationNo: '',
                mobile: '',
                isForeigner: false
              }
            ]
          },
          ...prev.confirmRooms.slice(roomIndex + 1)
        ]
      }))
    }
  }

  const handleDelete = (idx: number) => {
    setConfirmPrimitiveInput((prev) => ({
      ...prev,
      confirmRooms: [
        ...prev.confirmRooms.slice(0, roomIndex),
        {
          ...prev.confirmRooms[roomIndex],
          profiles: [
            ...prev.confirmRooms[roomIndex].profiles.slice(0, idx),
            ...prev.confirmRooms[roomIndex].profiles.slice(idx + 1)
          ]
        },
        ...prev.confirmRooms.slice(roomIndex + 1)
      ]
    }))
  }

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.header}>
        {getTranslate('Guest Details')}
      </Typography>
      <div className={classes.top}>
        <MeetingRoomIcon style={{ marginRight: 4, fontSize: 18 }} />
        <Typography variant="h5" className={classes.title} gutterBottom>
          {`${getTranslate('Room')} ${roomIndex + 1} - ${
            roomDetails.roomTypeName
          }`}
        </Typography>
      </div>
      {confirmPrimitiveInput.confirmRooms[roomIndex].profiles.map(
        (_, profileIndex) => (
          <div className={classes.form} key={profileIndex}>
            <Form
              key={profileIndex}
              confirmPrimitiveInput={confirmPrimitiveInput}
              setConfirmPrimitiveInput={setConfirmPrimitiveInput}
              roomIndex={roomIndex}
              profileIndex={profileIndex}
            />
            {confirmPrimitiveInput.confirmRooms[roomIndex].profiles.length >
              1 && (
              <IconButton
                className={classes.deleteIcon}
                onClick={() => {
                  handleDelete(profileIndex)
                }}>
                <DeleteIcon />
              </IconButton>
            )}
            {confirmPrimitiveInput.confirmRooms[roomIndex].profiles.length >
              1 &&
              roomIndex <
                confirmPrimitiveInput.confirmRooms[roomIndex].profiles.length -
                  1 && <Divider className={classes.divider} />}
          </div>
        )
      )}
      {confirmPrimitiveInput.confirmRooms[roomIndex].profiles.length <
        maxGuest && (
        <div className={classes.bottom} onClick={handleAddMore}>
          <AddCircleOutlineIcon className={classes.icon} />
          <Typography className={classes.redText}>
            {getTranslate('Add More Guest')}
          </Typography>
        </div>
      )}
      <div className={classes.row3}>
        <TextAreaWithLabel
          label={getTranslate('Description')}
          rows={5}
          onChange={(e) => {
            setConfirmPrimitiveInput({
              ...confirmPrimitiveInput,
              confirmRooms: [
                ...confirmPrimitiveInput.confirmRooms.slice(0, roomIndex),
                {
                  ...confirmPrimitiveInput.confirmRooms[roomIndex],
                  description: e.currentTarget.value
                },
                ...confirmPrimitiveInput.confirmRooms.slice(roomIndex + 1)
              ]
            })
          }}
        />
      </div>
    </div>
  )
}

export default GuestsDetailsForm
